var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLastStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "221px",
    height: "221px",
    viewBox: "0 0 221 221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3DEDA6D3-4ECD-4603-9E7C-BEA309AE62B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.5852479%",
    y1: "17.8917995%",
    x2: "88.2431771%",
    y2: "81.3233907%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8852CC",
    stopOpacity: 0.172412817,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5270CC",
    stopOpacity: 0.0962975543,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8AE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8852CC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "one-last-step-invite-code-enter",
    transform: "translate(-786.000000, -164.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(786.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Corporate-headquaters_511205",
    fill: "url(#linearGradient-1)",
    opacity: 0.643136161
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 110.5,
    cy: 110.5,
    r: 110.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111,54 C87.2218543,54 68,73.0829439 68,96.6892523 C68,107.856308 72.4139073,118.175234 79.5331126,125.808411 C79.6754967,126.091121 79.8178808,126.232477 80.102649,126.373832 C87.9337748,134.431075 98.897351,139.378505 111,139.378505 C134.778146,139.378505 154,120.295561 154,96.6892523 C154,73.0829439 134.778146,54 111,54 Z M87.9337748,125.242991 C97.9006623,121.850467 101.887417,117.751168 103.596026,114.78271 C105.589404,115.630841 107.86755,116.054907 110.288079,116.054907 C110.288079,116.054907 110.430464,116.054907 110.430464,116.054907 C110.430464,116.054907 110.572848,116.054907 110.715232,116.054907 C110.715232,116.054907 110.857616,116.054907 110.857616,116.054907 C113.562914,116.054907 115.983444,115.489486 118.119205,114.641355 C119.68543,117.609813 123.81457,121.850467 133.923841,125.242991 C127.65894,130.331776 119.543046,133.300234 110.857616,133.300234 C102.31457,133.300234 94.1986755,130.331776 87.9337748,125.242991 Z M119.258278,106.584112 C117.122517,108.845794 114.417219,109.976636 110.715232,110.117991 C110.715232,110.117991 110.572848,110.117991 110.572848,110.117991 C106.870861,110.117991 104.165563,108.98715 102.029801,106.584112 C96.6192053,100.647196 97.9006623,89.0560748 97.9006623,88.9147196 C97.9006623,88.9147196 97.9006623,88.7733645 97.9006623,88.7733645 C98.4701987,76.8995327 106.728477,75.6273364 110.288079,75.6273364 C110.430464,75.6273364 110.430464,75.6273364 110.572848,75.6273364 C110.715232,75.6273364 110.715232,75.6273364 110.857616,75.6273364 C110.857616,75.6273364 111,75.6273364 111.142384,75.6273364 C114.701987,75.6273364 122.960265,76.8995327 123.529801,88.7733645 C123.529801,88.7733645 123.529801,88.9147196 123.529801,88.9147196 C123.387417,89.0560748 124.668874,100.647196 119.258278,106.584112 Z M139.049669,120.578271 C125.807947,116.620327 123.672185,112.096963 123.387417,111.107477 C123.529801,110.966121 123.672185,110.683411 123.956954,110.542056 C130.791391,102.767523 129.794702,89.7628505 129.652318,88.3492991 C128.940397,74.4964953 119.258278,69.5490654 111.284768,69.5490654 C111.142384,69.5490654 111,69.5490654 110.857616,69.5490654 C110.715232,69.5490654 110.572848,69.5490654 110.430464,69.5490654 C102.31457,69.5490654 92.6324503,74.4964953 92.0629139,88.3492991 C91.9205298,89.7628505 90.781457,102.767523 97.7582781,110.542056 C98.0430464,110.966121 98.4701987,111.248832 98.7549669,111.531542 C98.0430464,112.945093 95.0529801,116.903037 83.2350993,120.436916 C77.397351,114.075935 73.9801325,105.735981 73.9801325,96.6892523 C73.9801325,76.4754673 90.4966887,59.9369159 111,59.9369159 C131.360927,59.9369159 148.019868,76.3341121 148.019868,96.6892523 C148.019868,105.735981 144.602649,114.075935 139.049669,120.578271 Z M145.029801,155.068925 C145.029801,156.765187 143.60596,158.037383 142.039735,158.037383 L80.102649,158.037383 C78.3940397,158.037383 77.1125828,156.623832 77.1125828,155.068925 C77.1125828,153.372664 78.5364238,152.100467 80.102649,152.100467 L142.039735,152.100467 C143.60596,152.100467 145.029801,153.372664 145.029801,155.068925 Z M134.066225,172.031542 C134.066225,173.727804 132.642384,175 131.076159,175 L90.9238411,175 C89.2152318,175 87.9337748,173.586449 87.9337748,172.031542 C87.9337748,170.476636 89.3576159,169.063084 90.9238411,169.063084 L131.076159,169.063084 C132.784768,169.063084 134.066225,170.33528 134.066225,172.031542 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLastStep);
export default __webpack_public_path__ + "static/media/one-last-step.f085b1d6597355cdf132fa5aac41d150.svg";
export { ForwardRef as ReactComponent };